<template>
  <g>
    <path
      d="M6.66667 29.3333C5.93333 29.3333 5.30556 29.0722 4.78333 28.55C4.26111 28.0278 4 27.4 4 26.6667V10.6667C4 9.93333 4.26111 9.30556 4.78333 8.78333C5.30556 8.26111 5.93333 8 6.66667 8H9.33333C9.33333 6.15556 9.98333 4.58333 11.2833 3.28333C12.5833 1.98333 14.1556 1.33333 16 1.33333C17.8444 1.33333 19.4167 1.98333 20.7167 3.28333C22.0167 4.58333 22.6667 6.15556 22.6667 8H25.3333C26.0667 8 26.6944 8.26111 27.2167 8.78333C27.7389 9.30556 28 9.93333 28 10.6667V26.6667C28 27.4 27.7389 28.0278 27.2167 28.55C26.6944 29.0722 26.0667 29.3333 25.3333 29.3333H6.66667ZM6.66667 26.6667H25.3333V10.6667H6.66667V26.6667ZM20.7167 16.7167C22.0167 15.4167 22.6667 13.8444 22.6667 12H20C20 13.1111 19.6111 14.0556 18.8333 14.8333C18.0556 15.6111 17.1111 16 16 16C14.8889 16 13.9444 15.6111 13.1667 14.8333C12.3889 14.0556 12 13.1111 12 12H9.33333C9.33333 13.8444 9.98333 15.4167 11.2833 16.7167C12.5833 18.0167 14.1556 18.6667 16 18.6667C17.8444 18.6667 19.4167 18.0167 20.7167 16.7167ZM12 8H20C20 6.88889 19.6111 5.94444 18.8333 5.16667C18.0556 4.38889 17.1111 4 16 4C14.8889 4 13.9444 4.38889 13.1667 5.16667C12.3889 5.94444 12 6.88889 12 8Z"
      :fill="iconColor"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#ffffff"
    }
  }
};
</script>
